import { ReactNode } from "react";

export function GlobalModalRoot({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
